module.exports = __webpack_public_path__ + "static/media/instagram.f9e8102b.svg";